import { config } from "../../constants/constant";

export const testerInviteEndpoints = {
  RESEND_TESTER_INVITE: config.BASE_URI + "/secure/api/v2/resend_tester_invite",
  CAPABILITY_CHECK: config.BASE_URI + "/secure/api/v2/do_cap_check ",
  // CAMPAIGN_LIST: config.BASE_URI + "/secure/rcsCampaigns",
};
